import { encodeParam } from "utilities/misc";
import { get } from "utilities/network";

export const httpGetTransaction = (id: any) => {
  return get(`vendor/transactions/get/${encodeParam(id)}`);
};
export const httpFetchTransactions = (
  channel: "user" | "admin",
  type: "withdrawal" | "deposit" | "all",
  status: "pending" | "successful" | "cancelled" | "all",
) => {
  return get(
    `vendor/transactions/fetch?channel=${encodeParam(channel)}&type=${encodeParam(type)}&status=${encodeParam(status)}`,
  );
};
